import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { OtpVerifyPage } from "@/components/Pages";

const otpVerifySearchSchema = z.object({
  phone: z.string().catch(""),
  resendAfter: z.number().catch(90),
});

export const Route = createFileRoute("/_auth/otp/verify")({
  validateSearch: otpVerifySearchSchema,
  beforeLoad: ({ search }) => {
    if (!search.phone) {
      throw redirect({ to: "/otp" });
    }
  },
  component: OtpVerifyPage,
});
